import { render, staticRenderFns } from "./EcosystemHome.vue?vue&type=template&id=9f27120e&scoped=true&"
import script from "./EcosystemHome.vue?vue&type=script&setup=true&lang=js&"
export * from "./EcosystemHome.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f27120e",
  null
  
)

export default component.exports